module.exports = __webpack_public_path__ + "static/media/img-booking-littleAvailable.8b5b80ed.svg";